<template lang="pug">
div
  app-display(
    label="Possui CAR?",
    :content="imovel.possuiCar ? 'Sim' : 'Não'"
    :class = "compararImovel && compararImovel.mudouPossuiCar ? 'text': '' "
  )
  app-display(
    label="Número do recibo:",
    :content="imovel.numeroReciboCar",
    v-if="imovel.numeroReciboCar",
    :marginBottom="true",
    :class = "compararImovel && compararImovel.mudouNumeroReciboCar ? 'text': '' "

  )
  app-display(
    label="Nome do Imóvel:",
    :content="imovel.nome",
    v-if="imovel.nome"
    :class = "compararImovel && compararImovel.mudouNome ? 'text': '' "
  )
  app-display(
    label="Município:",
    :content="imovel.municipio.nome",
    v-if="imovel.municipio"
    :class = "compararImovel && compararImovel.mudouMunicipio ? 'text': '' "
  )
  app-display(
    label="Área:",
    v-if="imovel.formattedValueArea"
    :content="imovel.formattedValueArea",
    :class = "compararImovel && compararImovel.mudouArea ? 'text': '' "
  )
  app-display(
    label="Finalidades:",
    :content="imovel.formattedValueFinalidades",
    v-if="imovel.formattedValueFinalidades"
    :class = "compararImovel && compararImovel.mudouFinalidadesImovel ? 'text': '' "
  )
  app-display(
    label="Descrição de acesso:",
    :content="imovel.descricaoAcesso",
    v-if="imovel.descricaoAcesso"
    :class = "compararImovel && compararImovel.mudouDescricaoAcesso ? 'text': '' "
  )

  div(v-if="imovel.ocupantesAnteriores !== null && !imovel.possuiCar")
    app-display(
      label="Há ocupantes anteriores?",
      :content="imovel.ocupantesAnteriores ? 'Sim' : 'Não'",
      v-if="imovel.ocupantesAnteriores !== null"
      :class = "compararImovel && compararImovel.mudouOcupantesAnteriores ? 'text': '' "
    )
    app-display(
      :label="'Possui outros imóveis rurais no ' + ESTADO + '?'",
      :content="imovel.possuiImovel ? 'Sim' : 'Não'",
      v-if="imovel.possuiImovel != null",
      :class = "compararImovel && compararImovel.mudouPossuiImovel ? 'text': '' "
    )
    app-display(
      label="Há conflitos no imóvel?",
      :content="imovel.conflitos ? 'Sim' : 'Não'",
      v-if="imovel.conflitos != null"
      :class = "compararImovel && compararImovel.mudouConflitos ? 'text': '' "
    )
    app-display(
      label="Número do processo judicial:",
      :content="imovel.numeroProcessoJudicial",
      v-if="imovel.numeroProcessoJudicial"
      :class = "compararImovel && compararImovel.mudouNumeroProcessoJudicial ? 'text': '' "
    )
    app-display(
      label="Tempo de ocupação:",
      :content="imovel.nomeTempoOcupacao",
      v-if="imovel.nomeTempoOcupacao !== null"
    )

</template>

<script>
import AppDisplay from '@/components/AppDisplay'
import { mapState } from 'vuex'

export default {

  components: {
    AppDisplay
  },

  props: {
    imovel: {
      type: Object,
      required: true
    },
    compararImovel: {
      type: Object,
      required: false
    }
  },

  computed: {
    ...mapState({
      ESTADO: state => state.userInterface.dadosEstado.ESTADO
    })
  }

}
</script>

<style lang="scss" scoped>
>>> .text .text{
    color: #ff0000 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/cadastrosOnline/InformacoesImovel.vue